import { makeStyles } from '@material-ui/styles';

import { toolbarMinHeight } from '../../service/constants';

export const useStyles = makeStyles((theme) => ({
    drawerClass: {
        flexShrink: 0,
        zIndex: '999 !important',
        whiteSpace: 'nowrap',
        minWidth: '350px',
    },
    drawerOpenClass: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerCloseClass: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        display: 'none',
    },
    drawerPaddingBottom: {
        paddingBottom: toolbarMinHeight,
    },
    drawerPaper: {
        paddingTop: toolbarMinHeight,
        width: 480,
        overflowX: 'hidden',
        whiteSpace: 'break-spaces',

        ['@media (max-width: 720px)']: {
            width: 320,
        },

        ['@media (max-width: 600px)']: {
            paddingTop: 60,
        },
    },
}));
